import type { FormatterParams } from '../../types'

export default {
  format: ({ value }: FormatterParams) => {
    return value.toUpperCase()
  }
}
